import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, ExternalLink } from 'lucide-react';
import { TESTIMONIALS, SOCIAL } from '../../data/content';

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-teal mb-4">
            — Testimonials —
          </p>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter max-w-3xl">
            What Teams Say<br />After Training.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ delay: 0.05 * i, duration: 0.5 }}
              data-testid={`testimonial-card-${i}`}
              className="comic-panel glass rounded-2xl p-7 flex flex-col border-2"
            >
              <Quote size={28} className="text-teal mb-4" />
              <p className="text-white/85 text-[15px] leading-relaxed flex-1">
                {t.quote}
              </p>
              <div className="mt-6 flex items-center gap-1.5 mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={13} className="text-teal fill-teal" />
                ))}
              </div>
              <div className="border-t border-white/5 pt-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-teal/30 to-white/5 border border-white/10 flex items-center justify-center font-display font-bold text-sm">
                  {t.name.split(' ').map((s) => s[0]).slice(0, 2).join('')}
                </div>
                <div>
                  <div className="font-display font-semibold text-sm text-white">{t.name}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-white/50">
                    {t.title} · {t.company}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href={SOCIAL.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="testimonials-linkedin"
            className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-white/70 hover:text-teal transition-colors"
          >
            Read all reviews on LinkedIn
            <ExternalLink size={13} />
          </a>
        </div>
      </div>
    </section>
  );
}
